export default __webpack_public_path__ + "static/media/icn-user-add-active.0c4826e5.svg";